import React, { useState } from "react";
import LoadingButton from '@mui/lab/LoadingButton';
import DownloadIcon from "@mui/icons-material/Download";

import { useTranslation } from "react-i18next";
import useMessage from "../util/useMessage";
import { MessageType } from "../util/Enums";

const DownloadButton = ({ service, ext = "csv" }) => {

    const { t } = useTranslation();
    const showMessage = useMessage();
    const [loading, setLoading] = useState(false);

    const onClick = async () => {
        try {
            setLoading(true);
            await service?.download();
            setLoading(false);
        } catch (e) {
            console.error(e);
            const { code, message } = e;
            showMessage(`Dosya İndirilemedi! ${code} - ${message}`, MessageType.ERROR);
            setLoading(false);
        }
    }

    return (
        <LoadingButton
            loading={loading}
            variant="contained"
            color="info"
            onClick={onClick}
            style={{ marginLeft: 10 }}
            startIcon={<DownloadIcon />}>
            {t('button.downloadTable')}
        </LoadingButton>
    )
}

export default DownloadButton;
